export enum ScreenSize {
    SM = 0,  // < 640px
    MD = 1,  // >= 640px
    LG = 2,  // >= 768px
    XL = 3,  // >= 1024px
    XXL = 4  // >= 1280px (using 'XXL' instead of '2XL' for valid enum naming)
}

const BREAKPOINTS = {
    MD: 640,   // sm/md boundary
    LG: 768,   // md/lg boundary
    XL: 1024,  // lg/xl boundary
    XXL: 1280  // xl/2xl boundary
};

export function getScreenSize(): ScreenSize {
    const width = window.innerWidth;

    if (width >= BREAKPOINTS.XXL) {
        return ScreenSize.XXL;
    } else if (width >= BREAKPOINTS.XL) {
        return ScreenSize.XL;
    } else if (width >= BREAKPOINTS.LG) {
        return ScreenSize.LG;
    } else if (width >= BREAKPOINTS.MD) {
        return ScreenSize.MD;
    } else {
        return ScreenSize.SM;
    }
}

export function detectOS(): string {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf('Windows') !== -1) {
        return 'Windows';
    } else if (userAgent.indexOf('Macintosh') !== -1) {
        return 'Macintosh';
    } else if (userAgent.indexOf('Linux') !== -1) {
        return 'Linux';
    } else {
        return 'Other';
    }
}
